// No @sentry/* imports — shared by `context.ts` (eager) and `feedback.ts`
// (lazy chunk) without pulling the lazy chunk back into the main bundle.

export interface FeedbackPrefill {
  name: string;
  email: string;
}

let prefill: FeedbackPrefill | null = null;

export function setFeedbackPrefill(next: FeedbackPrefill | null) {
  prefill = next;
}

export function getFeedbackPrefill(): FeedbackPrefill | null {
  return prefill;
}

let feedbackEnabled = false;

export function setFeedbackEnabled(enabled: boolean) {
  feedbackEnabled = enabled;
}

export function isFeedbackEnabled(): boolean {
  return feedbackEnabled;
}
